import {
 LOADING_TOGGLE_ACTION,
 LOGIN_CONFIRMED_ACTION,
 LOGIN_FAILED_ACTION,
 LOGOUT_ACTION,
 SIGNUP_CONFIRMED_ACTION,
 SIGNUP_FAILED_ACTION,
} from '../actions/AuthActions';

// [OK] Load from localStorage if available
const storedToken = localStorage.getItem('token');
const storedUser = localStorage.getItem('userDetails')
 ? JSON.parse(localStorage.getItem('userDetails'))
 : null;

const initialState = {
 auth: {
 email: storedUser?.email || '',
 idToken: storedToken || '',
 localId: storedUser?._id || '',
 expiresIn: '',
 refreshToken: '',
 },
 userDetails: storedUser || null,
 errorMessage: '',
 successMessage: '',
 showLoading: false,
 authChecked: !!storedToken, // [OK] auto mark if token found
};

export function AuthReducer(state = initialState, action) {
 switch (action.type) {
 case SIGNUP_CONFIRMED_ACTION: {
 const { user, token } = action.payload;
 // [OK] Save in localStorage
 localStorage.setItem('token', token);
 localStorage.setItem('userDetails', JSON.stringify(user));

 return {
 ...state,
 auth: {
 email: user.email,
 idToken: token,
 localId: user._id,
 expiresIn: '',
 refreshToken: '',
 },
 userDetails: user,
 errorMessage: '',
 successMessage: 'Signup Successfully Completed',
 showLoading: false,
 };
 }

 case LOGIN_CONFIRMED_ACTION: {
 const { user, token } = action.payload;
 // [OK] Save in localStorage
 localStorage.setItem('token', token);
 localStorage.setItem('userDetails', JSON.stringify(user));

 return {
 ...state,
 auth: {
 email: user.email,
 idToken: token,
 localId: user._id,
 expiresIn: '',
 refreshToken: '',
 },
 userDetails: user,
 errorMessage: '',
 successMessage: 'Login Successfully Completed',
 showLoading: false,
 };
 }

 case LOGOUT_ACTION:
 // [OK] Clear localStorage on logout
 localStorage.removeItem('token');
 localStorage.removeItem('userDetails');
 return {
 ...state,
 auth: {
 email: '',
 idToken: '',
 localId: '',
 expiresIn: '',
 refreshToken: '',
 },
 userDetails: {
 name: '',
 mobile: '',
 role: '',
 },
 errorMessage: '',
 successMessage: '',
 };

 case SIGNUP_FAILED_ACTION:
 case LOGIN_FAILED_ACTION:
 return {
 ...state,
 errorMessage: action.payload,
 successMessage: '',
 showLoading: false,
 };

 case LOADING_TOGGLE_ACTION:
 return {
 ...state,
 showLoading: action.payload,
 };

 case 'AUTH_CHECKED':
 return {
 ...state,
 authChecked: true,
 };

 case 'UPDATE_USER_DETAILS': {
 const updatedUser = { ...state.userDetails, ...action.payload };
 localStorage.setItem('userDetails', JSON.stringify(updatedUser));
 return {
 ...state,
 userDetails: updatedUser,
 };
 }

 default:
 return state;
 }
}
